var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscipleCoverOnDisplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229,
    height: 93,
    viewBox: "0 0 229 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148058",
    "data-name": "Rectangle 148058",
    width: 229,
    height: 93,
    rx: 10,
    transform: "translate(0)",
    fill: "#f2bbab"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148073",
    "data-name": "Rectangle 148073",
    width: 229,
    height: 114.527,
    transform: "translate(0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disciple_Cover_On_Display",
    "data-name": "Disciple Cover On Display",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Disciple_BG",
    "data-name": "Disciple BG",
    transform: "translate(0 -10.764)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148072",
    "data-name": "Rectangle 148072",
    width: 229,
    height: 114.527,
    transform: "translate(0)",
    fill: "#faf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    d: "M229.212,96.967c3.4-.452,7-.686,9.839-3.168,2.441-2.129,3.966-5.613,5.4-8.971l5.616-13.138a40.5,40.5,0,0,1,3.125-6.3c2.326-3.572,5.546-5.873,8.406-8.707,5.261-5.19,9.8-12.48,16.245-14.217a6.864,6.864,0,0,1,5.287.485c3.879,2.243,5.058,8.553,6.08,13.949a134.243,134.243,0,0,0,5.306,19.778c1.65,4.665,3.6,9.768,2.513,14.7-.734,3.3-2.726,5.851-4.661,8.189-7.518,9.089-15.469,17.755-24.576,23.86-6.8,4.6-14.137,7.676-21.42,10.726-7.241,3.028-14.522,6.068-22.012,7.709-3.161.69-6.44,1.1-9.537.044-2.544-.877-4.823-2.716-7.158-4.313a47.718,47.718,0,0,0-9.431-5.036c-2.075-.819-4.368-1.63-5.616-3.961-1.117-2.074-2.709-8.63-2.092-11.115.785-3.175,5.007-5.466,7.015-7A70.306,70.306,0,0,1,217.427,99.76,61.35,61.35,0,0,1,229.212,96.967Z",
    transform: "translate(-46.138 -0.173)",
    fill: "#efc041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5931",
    "data-name": "Path 5931",
    d: "M78.34,4.719a118.476,118.476,0,0,1,7.417-9.511",
    transform: "translate(-18.984 0.02)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    d: "M80.909,6.059A138.582,138.582,0,0,1,91.547-8.256",
    transform: "translate(-19.607 0.034)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5933",
    "data-name": "Path 5933",
    d: "M85.745,5.77A86.376,86.376,0,0,1,93.269-4.674",
    transform: "translate(-20.779 0.019)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5934",
    "data-name": "Path 5934",
    d: "M87.275,8.482a81.058,81.058,0,0,1,9.8-14.969",
    transform: "translate(-21.15 0.027)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    d: "M90.588,9.377a83.462,83.462,0,0,1,9.7-16.012",
    transform: "translate(-21.953 0.027)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5936",
    "data-name": "Path 5936",
    d: "M95.708,5.305a65.841,65.841,0,0,1,6.077-10.388",
    transform: "translate(-23.193 0.021)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5937",
    "data-name": "Path 5937",
    d: "M96.441,6.493a73.221,73.221,0,0,1,6.9-11.875",
    transform: "translate(-23.371 0.022)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5938",
    "data-name": "Path 5938",
    d: "M98.753,5.76a110.32,110.32,0,0,1,7.2-12.818",
    transform: "translate(-23.931 0.029)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5939",
    "data-name": "Path 5939",
    d: "M101.889,5.585A90.128,90.128,0,0,1,109.03-7.42c.053-.081.134-.165.2-.114s-.061.213-.064.106",
    transform: "translate(-24.691 0.031)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    "data-name": "Path 5940",
    d: "M104.178,5.44q3.734-7.421,8.026-14.316",
    transform: "translate(-25.246 0.037)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    "data-name": "Path 5941",
    d: "M107.628,4.077,114.3-8.253",
    transform: "translate(-26.082 0.034)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M109.63,4.1q2.858-6.009,6.183-11.6",
    transform: "translate(-26.567 0.031)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5943",
    "data-name": "Path 5943",
    d: "M111.583,4.087q2.773-5.994,5.865-11.746",
    transform: "translate(-27.04 0.032)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5944",
    "data-name": "Path 5944",
    d: "M113.706,3.329a134.832,134.832,0,0,1,7.32-13.119",
    transform: "translate(-27.555 0.04)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    "data-name": "Path 5945",
    d: "M119.493.79q4.027-6.842,8.523-13.182",
    transform: "translate(-28.957 0.051)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    "data-name": "Path 5946",
    d: "M124.583-1.065q3.2-6.468,6.9-12.481",
    transform: "translate(-30.191 0.056)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5947",
    "data-name": "Path 5947",
    d: "M121.554,1.953a57.623,57.623,0,0,0,4.954-14.441",
    transform: "translate(-29.456 0.051)",
    fill: "none",
    stroke: "#f1e1c5",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5948",
    "data-name": "Path 5948",
    d: "M-40.059,74.562C-23.7,89.979-3.567,97.056,16.425,100.213s40.215,2.705,60.283,4.688c19.3,1.909,38.461,6.064,57.809,7.195a185.775,185.775,0,0,0,43.125-2.511c4.767-.837,9.749-1.835,14.285.268v23.126H-53.523V80.329l14.4-5.767",
    transform: "translate(12.97 -0.307)",
    fill: "#b98a68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5949",
    "data-name": "Path 5949",
    d: "M5.429,75.673c1.483,1.968,2.918,4,4.516,5.8a58.355,58.355,0,0,0,7.024,6.413,94.435,94.435,0,0,0,9.674,7.22,39.223,39.223,0,0,1,6.122,4.063,2.829,2.829,0,0,1,.888,1.2,4.11,4.11,0,0,1-.02,2.041A33.573,33.573,0,0,1,29.6,113.265c-2.044,3.443-4.647,6.24-6.982,9.335-4.164,5.528-7.9,12.436-13.612,14.492a2.421,2.421,0,0,1-1.631.147,3.731,3.731,0,0,1-1.676-1.89,57.759,57.759,0,0,1-3.4-9.221,146.017,146.017,0,0,0-12.98-29.381c-2.695-4.607-5.633-9-7.948-13.949A75.159,75.159,0,0,1-23.8,66.8c-.7-3.234-3.455-12.631-1.528-15.527,2.209-3.322,7.593,1.689,9.6,3.179a99.039,99.039,0,0,1,10.6,9.118,111.158,111.158,0,0,1,10.565,12.1Z",
    transform: "translate(6.3 -0.206)",
    fill: "#de8739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5950",
    "data-name": "Path 5950",
    d: "M161.99-39.683a11.8,11.8,0,0,0-4.6,7.107,15.592,15.592,0,0,0,.608,9.3A118.611,118.611,0,0,0,170.865.776C176.6,8.969,183.581,16.248,191.847,18.7c10.66,3.157,22.286-2.03,32.518,3.01,9.478,4.673,15.854,17.278,25.525,21.2a7.694,7.694,0,0,0,5.5.488c2.058-.734,3.7-2.713,5.261-4.629L270.6,26.515c2.463-3.036,5.027-6.24,6.069-10.476.857-3.447.606-7.18.313-10.788-.6-7.378-1.4-14.969-4.223-21.382-3.552-8.024-9.911-13.233-16.457-16.72-11.372-6.093-23.771-7.943-36.012-9.2A424.319,424.319,0,0,0,176.87-44.3a21.31,21.31,0,0,0-6.51.672A32.925,32.925,0,0,0,161.99-39.683Z",
    transform: "translate(-38.034 0.182)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5951",
    "data-name": "Path 5951",
    d: "M-22.923,12.211q2.463-9.239,4.929-18.475c1.125-4.225,2.31-8.571,4.619-11.875a22.942,22.942,0,0,1,6.649-5.976,79.105,79.105,0,0,1,37.143-12.7,16.664,16.664,0,0,1,6.219.367,5.26,5.26,0,0,1,3.692,3.436,8.219,8.219,0,0,1,.106,3.495c-.748,5.279-3.443,9.661-5.2,14.5A92.764,92.764,0,0,0,32.319-4.006C29.652,7.615,26.036,19.435,19.085,27.43A8.322,8.322,0,0,1,15.871,30a7.339,7.339,0,0,1-4.449-.316c-3.4-.976-6.85-2.111-9.746-4.64C-.6,23.058-2.469,20.272-4.938,18.73c-2.955-1.835-6.4-1.641-9.526-2.9-2.379-.954-4.519-2.727-6.831-3.931",
    transform: "translate(5.555 0.152)",
    fill: "#a35d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5952",
    "data-name": "Path 5952",
    d: "M93.838,12.524c3.577,1.366,7.3,2.371,11.012,1.927,3.53-.418,6.887-2.125,10.308-3.344a79.415,79.415,0,0,1,11.07-2.8l8.59-1.733c1.835-.367,3.885-.914,4.9-2.937a10.423,10.423,0,0,0,.732-2.423A79.128,79.128,0,0,0,141.97-7.2a18.218,18.218,0,0,0-.092-5.565c-.67-3.322-2.689-5.833-4.619-8.156-1.3-1.564-2.748-3.216-4.507-3.351a6.248,6.248,0,0,0-2.944.8l-5.7,2.6a38.119,38.119,0,0,0-8.331,4.677c-3.041,2.423-5.571,5.774-8.264,8.81A69.9,69.9,0,0,1,93.422,4.929c-1.19.782-3.469,2.158-3.276,4.342C90.325,11.279,92.634,12.069,93.838,12.524Z",
    transform: "translate(-21.843 0.1)",
    fill: "#a35d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5953",
    "data-name": "Path 5953",
    d: "M223,11.735a55.755,55.755,0,0,0,6.733,4.827c8.49,5.458,17,10.939,25.911,15.1a103.332,103.332,0,0,0,14.109,5.385,8.14,8.14,0,0,0,3.745.485A9.68,9.68,0,0,0,277.25,35.5l6.518-4.834a2.733,2.733,0,0,0,1.05-1.211,4.123,4.123,0,0,0-.02-2.019l-1.4-7.485a30.741,30.741,0,0,0-1.645-6.332,16.193,16.193,0,0,0-5.379-6.607c-6.828-5.121-15.033-5.528-22.746-7.54-4.08-1.065-8.082-2.6-12.173-3.594a93.5,93.5,0,0,0-11.534-1.813c-3.991-.451-13.684-3.873-15.854,2.57C212.206,2.2,220.087,9.191,223,11.735Z",
    transform: "translate(-51.808 0.03)",
    fill: "#7e9be0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5954",
    "data-name": "Path 5954",
    d: "M232.147,11.244a78.067,78.067,0,0,0,8.808,5.139c2.321,1.1,4.708,1.968,7,3.168,2.4,1.255,4.692,2.871,7.088,4.166a62.334,62.334,0,0,0,13.059,4.75l22.233,6.24a1.563,1.563,0,0,0,.991.059c.8-.308.983-1.674,1.011-2.771q.2-7.731-.05-15.465a10.9,10.9,0,0,0-.838-4.643c-.969-1.872-2.821-2.485-4.507-2.937-12.656-3.564-25.338-7.1-38.12-9.9-6.381-1.4-12.788-2.617-19.216-3.561C227-4.878,215.924-8.794,217.041-2.37c.584,3.447,3.656,5.323,5.719,6.993A110.787,110.787,0,0,0,232.147,11.244Z",
    transform: "translate(-52.577 0.025)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5955",
    "data-name": "Path 5955",
    d: "M4.808,91.885c4.061-1.659,7.937-3.953,12.1-5.2s8.814-1.336,12.634,1.263c3.047,2.074,6.024,5.9,9.316,4.772,1.329-.451,2.36-1.663,3.429-2.713A19.767,19.767,0,0,1,50.784,85a6.987,6.987,0,0,1,3.63-.22,9.8,9.8,0,0,1,3.455,2.048c6.122,4.9,11.9,10.421,17.661,15.938l7.381,7.062c1.569,1.5,3.139,3.006,4.608,4.654a50.228,50.228,0,0,1,11.626,25.291c.344,2.173.494,4.669-.681,6.3a5.541,5.541,0,0,1-2.818,1.835c-9.543,3.355-19.828.459-29.826-.8-10.38-1.3-20.805-.793-31.217-.98S13.641,145.034,3.674,141a48.526,48.526,0,0,1-25.039-22.333c-3.538-6.8-5.636-15.784,1.5-19.128C-11.937,95.813-3.233,95.171,4.808,91.885Z",
    transform: "translate(5.967 -0.348)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5956",
    "data-name": "Path 5956",
    d: "M-10.274,82.157A53.319,53.319,0,0,1-.751,77.205c2.793-.987,5.7-1.468,8.28-3.138C11.1,71.762,13.623,67.46,16.4,63.73a55.2,55.2,0,0,1,7.47-8.244,1.89,1.89,0,0,0,.656-.888,2.27,2.27,0,0,0-.279-1.553c-1.575-3.3-4.468-5.025-7.077-6.846C12.023,42.635,7.292,38.031,1.93,35.076-1.662,33.1-5.476,31.9-9.126,30.1c-4.5-2.2-8.811-5.37-13.572-6.266a271.512,271.512,0,0,1-3.2,28.3c-.673,4.53-1.346,9.059-2.145,13.552-.871,4.9-1.893,9.742-2.773,14.635-.461,2.57-3.024,11.9-1.042,13.875,1.69,1.681,8.479-4.071,10.333-5.194Z",
    transform: "translate(7.9 -0.098)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DISCIPLE",
    transform: "translate(88.763 55.145)",
    fill: "#222d44",
    fontSize: 9,
    fontFamily: "Segoe UI",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DISCIPLE")), /*#__PURE__*/React.createElement("text", {
    id: "Road_to_mastery",
    "data-name": "Road to mastery",
    transform: "translate(102.042 64.749)",
    fill: "#222d44",
    fontSize: 2,
    fontFamily: "Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Road "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "o mas"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.02em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("path", {
    id: "Path_5957",
    "data-name": "Path 5957",
    d: "M-2.367,24.383a53.41,53.41,0,0,0,8.937,1.575,15.23,15.23,0,0,0,6.376-.206c4.887-1.556,8.18-7.584,10.191-13.64S26.381-.552,29.321-5.915C33.424-13.4,40.252-17.39,45.24-23.9a37.433,37.433,0,0,0,4.979-8.839,11.759,11.759,0,0,0,1.042-4.548c-.056-2.445-1.346-4.5-2.583-6.332A77.964,77.964,0,0,0,39.9-54.893a72.471,72.471,0,0,0-8.861-7.253L19.793-70.406A5.908,5.908,0,0,0,17.4-71.661a5.151,5.151,0,0,0-3.491,1.222c-7.3,4.9-13.391,12.514-18.4,21.052S-13.5-31.4-17.42-21.934c-3.63,8.758-7.216,17.66-9.1,27.314-1.3,6.7-.536,15.417,5.923,14.433C-14.211,18.844-8.5,22.6-2.367,24.383Z",
    transform: "translate(6.556 0.295)",
    fill: "#efc041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5958",
    "data-name": "Path 5958",
    d: "M-19.542,96.7c12.193-3.3,24.9-7.782,37.422-8.846a19.66,19.66,0,0,1,7.727.415c3.591,1.142,6.85,4.2,10.528,4.243,5.77.066,10.054-7.25,15.818-7.217,3.092,0,5.993,2.2,8.213,4.941s3.924,6.005,5.918,8.986c8.378,12.514,21.3,19.088,30.8,30.335,2.15,2.547,4.267,6.159,3.24,9.481-.838,2.753-3.46,3.876-5.795,4.629a140.143,140.143,0,0,1-46.978,6.751c-12.743-.367-26.028-2.687-36.841-11.409-3.441-2.775-6.546-6.13-9.858-9.133-5.306-4.82-11.14-8.7-16.563-13.328a19.6,19.6,0,0,1-3.759-3.95,15.1,15.1,0,0,1,.131-15.9c-.226.631-.45,1.266-.676,1.9",
    transform: "translate(5.299 -0.351)",
    fill: "#74aea7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5959",
    "data-name": "Path 5959",
    d: "M9.658,98.688c2.832-1.2,5.756-2.412,8.786-2.2,2.985.213,5.837,1.8,8.805,2.338,6.568,1.193,13.106-2.815,19.649-1.366,3.3.734,6.325,2.8,9.275,4.842l16.957,11.717a82.986,82.986,0,0,1,10.6,8.219,50.446,50.446,0,0,1,10.241,14.353,7.962,7.962,0,0,1,1.081,4.464c-.338,2.338-2.421,3.5-4.264,4.2a62.416,62.416,0,0,1-7.736,2.375c-17.544,4.181-35.975.892-53.488-5.011s-34.442-14.364-51.835-20.831c-2.234-.833-7.873-3.539-4.921-7.253,1.218-1.531,4.156-2.041,5.795-2.731l6.256-2.643Z",
    transform: "translate(6.793 -0.397)",
    fill: "#efc041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5960",
    "data-name": "Path 5960",
    d: "M-11.108,98.767C-7.363,97.1-3.649,94.887.4,95.1c5.158.275,9.864,4.445,14.994,5.462,4.809.954,9.7-.921,14.455.5,5.848,1.747,10.154,7.988,14.731,13,7.359,8.076,16.611,14.132,21.579,24.616A15.976,15.976,0,0,1,68,146.7a3.011,3.011,0,0,1-.559,1.7,2.218,2.218,0,0,1-1.516.6c-19.387,2.232-39.215-3.127-58.188-10.594a117.032,117.032,0,0,1-19.043-9.177,160.445,160.445,0,0,1-13.4-9.713l-8.853-6.89c-1.882-1.468-5.77-4.4-4.7-7.742,1.03-3.223,5.555-1.835,7.725-1.835a47.868,47.868,0,0,0,19.437-4.287Z",
    transform: "translate(9.318 -0.391)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5961",
    "data-name": "Path 5961",
    d: "M73.251,7.341c2.818,2.592,5.767,5.506,9.216,5.649a12.973,12.973,0,0,0,5.306-1.354l22.121-9.1c2.435-1.02,5.058-2.2,6.493-4.974a2.439,2.439,0,0,0,.33-1.1,2,2,0,0,0-1.569-1.784c-4.407-1.468-9.026.143-13.57.261-4.608.121-9.149-1.3-13.72-2.078a99.73,99.73,0,0,0-17.594-.9,16.873,16.873,0,0,0-5.89.734c-1.1.407-3.388,1.5-3.871,3.039-.715,2.287,1.676,2.856,2.971,3.751a91.169,91.169,0,0,1,9.777,7.852Z",
    transform: "translate(-14.63 0.033)",
    fill: "#74aea7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5962",
    "data-name": "Path 5962",
    d: "M213.735-.033c12.439,5.249,22.9,17.722,35.794,20.472,5.105,1.1,10.333.576,15.457,1.608,6.208,1.252,12.036,4.735,18.194,6.354a5.113,5.113,0,0,0,3.234.081c2.332-.947,3.276-4.563,3.723-7.709a96.43,96.43,0,0,0,.885-9.977,27.535,27.535,0,0,0-.466-7.283A16.927,16.927,0,0,0,284.937-5.4c-4.957-4.24-11.042-5.554-16.952-5.844s-11.849.334-17.734-.466c-5.831-.789-11.514-2.97-17.334-3.843a86.508,86.508,0,0,0-14.946-.411,46.563,46.563,0,0,0-11.059,1.123c-1.994.54-12.511,5.073-9.445,8.883,1.572,1.953,5.784,2.445,7.836,3.087C208.127-1.993,210.97-1.2,213.735-.033Z",
    transform: "translate(-47.718 0.066)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5963",
    "data-name": "Path 5963",
    d: "M206.173,116.781c2.689-3.876,5.284-8.1,8.543-10.568,8.895-6.75,20.7.91,28.723-8.266,5.557-6.361,7.241-18.691,12.009-26.569,2.974-4.919,7.046-7.914,9.724-13.266,1.651-3.3,2.681-7.3,4.189-10.781a25.275,25.275,0,0,1,5.613-8.377c1.617-1.527,3.5-2.654,5.359-2.052,3.672,1.189,5.37,8.076,6.423,13.974q4.273,23.97,8.548,47.94c.76,4.269,1.516,8.894.575,13.005a11.388,11.388,0,0,1-5.683,7.808c-2.458,1.241-5.083,1.307-7.663,1.545a114.162,114.162,0,0,0-16.72,3.249l-27.67,6.813c-6.742,1.659-13.634,3.3-20.387,1.252-3.859-1.186-7.766-3.583-11.59-2.353-1.776.573-3.413,1.9-5.1,2.937-2.114,1.3-4.731,2.691-7.038,2.592-2.558-.11-1.042-3.26.26-4.555a103.238,103.238,0,0,0,11.886-14.327Z",
    transform: "translate(-46.683 -0.151)",
    fill: "#a35d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5964",
    "data-name": "Path 5964",
    d: "M265.269,49.107c.559,1.747.922,3.671,1.885,5.08s2.829,2.019,3.812.631c.533-.756.684-1.916,1.3-2.57.279-.3.654-.448.944-.734a4.255,4.255,0,0,0,.813-1.615,16.6,16.6,0,0,0,1.251-6.472,6.7,6.7,0,0,0-.436-2.015c-1.257-3.124-4.044-2.621-6.239-3.693-.771-.367-1.477-.954-2.234-1.332-1.743-.848-3.672-.635-5.493-.569a2.121,2.121,0,0,0-1.4.6c-1.826,1.762,1.2,4.13,2,5.319A29.067,29.067,0,0,1,265.269,49.107Z",
    transform: "translate(-62.741 -0.147)",
    fill: "#74aea7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5965",
    "data-name": "Path 5965",
    d: "M258.481,95.606a13.8,13.8,0,0,1,5.465-1.9,23.621,23.621,0,0,0,2.7,0,9.177,9.177,0,0,0,3.963-2.239c3.667-2.937,7.448-6.013,9.883-10.645.26-.5.559-1.065,1.025-1.1.525-.059.919.587,1.209,1.167,3.566,7.147,6.82,15.076,6.831,23.621a9.252,9.252,0,0,1-.525,3.557,7.551,7.551,0,0,1-2.178,2.669c-3.684,3.263-7.392,6.549-11.478,8.846-4.965,2.793-10.355,4.038-15.728,4.794-12.084,1.681-24.282.9-36.422.125l-15.689-1.009a38.466,38.466,0,0,1-6.4-.771c-1.218-.283-5.49-.9-5.809-2.764-.422-2.463,3.178-3.19,4.234-3.6,4.722-1.835,9.5-3.417,14.279-4.926,9.573-3.014,19.216-5.671,28.717-9.081A154.536,154.536,0,0,0,258.481,95.606Z",
    transform: "translate(-47.326 -0.328)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5966",
    "data-name": "Path 5966",
    d: "M56.545,41.505a.7.7,0,0,0-.148.5.5.5,0,0,0,.279.3l4.951,3.065a1.25,1.25,0,0,0,1.022.279,1.369,1.369,0,0,0,.673-1.171,5.34,5.34,0,0,0-.148-1.531,15.772,15.772,0,0,1-.366-4.632c.173-1.468.734-2.826,1.047-4.265,1.117-5.172-1.511-1.707-2.759.264Z",
    transform: "translate(-13.666 -0.129)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5967",
    "data-name": "Path 5967",
    d: "M7.271,13.611a.571.571,0,0,0,0-1.1.571.571,0,0,0,0,1.1Z",
    transform: "translate(-1.66 -0.051)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5968",
    "data-name": "Path 5968",
    d: "M9.875,17.749v.15a.591.591,0,0,0,.036.213.489.489,0,0,0,.087.176.314.314,0,0,0,.137.114.258.258,0,0,0,.159.048h.112a.428.428,0,0,0,.187-.143l.064-.11a.676.676,0,0,0,.056-.279v-.15a.532.532,0,0,0-.034-.213.448.448,0,0,0-.223-.29.24.24,0,0,0-.162-.048l-.109.018a.4.4,0,0,0-.187.143l-.064.11a.724.724,0,0,0-.059.279Z",
    transform: "translate(-2.393 -0.071)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5969",
    "data-name": "Path 5969",
    d: "M20.728,15.878a.571.571,0,1,0-.419-.551A.5.5,0,0,0,20.728,15.878Z",
    transform: "translate(-4.922 -0.061)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5970",
    "data-name": "Path 5970",
    d: "M20.426,18.3a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-4.848 -0.071)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5971",
    "data-name": "Path 5971",
    d: "M22.7,18h.115a.43.43,0,0,0,.3-.162.489.489,0,0,0,.087-.176.6.6,0,0,0,.036-.213l-.017-.147a.614.614,0,0,0-.106-.242l-.087-.1a.345.345,0,0,0-.209-.073H22.7a.24.24,0,0,0-.162.048.457.457,0,0,0-.221.29.492.492,0,0,0-.036.213l.014.147a.6.6,0,0,0,.109.242l.084.084a.336.336,0,0,0,.212.077Z",
    transform: "translate(-5.398 -0.069)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5972",
    "data-name": "Path 5972",
    d: "M21.182,4.083a.5.5,0,0,0,.419-.551.435.435,0,1,0-.838,0A.5.5,0,0,0,21.182,4.083Z",
    transform: "translate(-5.031 -0.012)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5973",
    "data-name": "Path 5973",
    d: "M21.786,15.576a.571.571,0,1,0-.419-.551A.5.5,0,0,0,21.786,15.576Z",
    transform: "translate(-5.178 -0.06)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5974",
    "data-name": "Path 5974",
    d: "M18.612,11.193a.5.5,0,0,0,.419-.551.435.435,0,1,0-.838,0,.5.5,0,0,0,.419.551Z",
    transform: "translate(-4.409 -0.042)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5975",
    "data-name": "Path 5975",
    d: "M20.728,7.714a.5.5,0,0,0,.419-.551.435.435,0,1,0-.838,0,.5.5,0,0,0,.419.551Z",
    transform: "translate(-4.922 -0.027)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5976",
    "data-name": "Path 5976",
    d: "M22.545,15.727a.571.571,0,1,0-.419-.551A.5.5,0,0,0,22.545,15.727Z",
    transform: "translate(-5.362 -0.06)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5977",
    "data-name": "Path 5977",
    d: "M23.456,22.384a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-5.583 -0.088)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5978",
    "data-name": "Path 5978",
    d: "M26.172,5.6a.5.5,0,0,0,.419-.551.435.435,0,1,0-.838,0A.5.5,0,0,0,26.172,5.6Z",
    transform: "translate(-6.241 -0.019)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5979",
    "data-name": "Path 5979",
    d: "M8.631,6.5a.5.5,0,0,0,.419-.551A.5.5,0,0,0,8.631,5.4a.5.5,0,0,0-.419.551A.5.5,0,0,0,8.631,6.5Z",
    transform: "translate(-1.99 -0.022)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5980",
    "data-name": "Path 5980",
    d: "M18.159,22.384a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-4.299 -0.088)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5981",
    "data-name": "Path 5981",
    d: "M18.3,19.509a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-4.332 -0.076)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5982",
    "data-name": "Path 5982",
    d: "M17.4,20.718a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-4.116 -0.081)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5983",
    "data-name": "Path 5983",
    d: "M20.612,19.109v.15a.591.591,0,0,0,.036.213.448.448,0,0,0,.223.29.227.227,0,0,0,.159.048h.112a.384.384,0,0,0,.184-.143l.067-.11a.722.722,0,0,0,.056-.279v-.151a.492.492,0,0,0-.036-.213.449.449,0,0,0-.087-.176.285.285,0,0,0-.134-.114.26.26,0,0,0-.162-.048h-.112a.439.439,0,0,0-.184.143l-.064.11A.677.677,0,0,0,20.612,19.109Z",
    transform: "translate(-4.995 -0.076)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5984",
    "data-name": "Path 5984",
    d: "M35.1,8.167a.5.5,0,0,0,.419-.551.435.435,0,1,0-.838,0A.5.5,0,0,0,35.1,8.167Z",
    transform: "translate(-8.403 -0.029)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5985",
    "data-name": "Path 5985",
    d: "M38.723,3.781a.5.5,0,0,0,.419-.551.435.435,0,1,0-.838,0A.5.5,0,0,0,38.723,3.781Z",
    transform: "translate(-9.282 -0.011)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5986",
    "data-name": "Path 5986",
    d: "M2.129,18.148a.571.571,0,0,0,0-1.1.571.571,0,0,0,0,1.1Z",
    transform: "translate(-0.414 -0.07)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5987",
    "data-name": "Path 5987",
    d: "M29.954,18.6a.571.571,0,1,0-.419-.551A.5.5,0,0,0,29.954,18.6Z",
    transform: "translate(-7.157 -0.072)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5988",
    "data-name": "Path 5988",
    d: "M267.894,97.343l.226-.154a.639.639,0,0,0,.193-.33.586.586,0,0,0,0-.22.524.524,0,0,0-.05-.206l-.067-.11a.406.406,0,0,0-.184-.143l-.112-.018a.329.329,0,0,0-.209.077l-.229.154a.43.43,0,0,0-.117.143.417.417,0,0,0-.073.187.477.477,0,0,0,0,.22.524.524,0,0,0,.05.206l.064.11a.43.43,0,0,0,.184.139l.112.022A.342.342,0,0,0,267.894,97.343Z",
    transform: "translate(-64.765 -0.396)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5989",
    "data-name": "Path 5989",
    d: "M271.447,90.127a.571.571,0,1,0-.419-.551A.5.5,0,0,0,271.447,90.127Z",
    transform: "translate(-65.679 -0.366)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5990",
    "data-name": "Path 5990",
    d: "M276.74,81.358a.571.571,0,1,0-.419-.551A.5.5,0,0,0,276.74,81.358Z",
    transform: "translate(-66.962 -0.33)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5991",
    "data-name": "Path 5991",
    d: "M287.013,70.911l.344-.452a.5.5,0,0,0,.089-.176.547.547,0,0,0,.034-.213.532.532,0,0,0-.034-.213.441.441,0,0,0-.089-.176l-.084-.088a.347.347,0,0,0-.212-.073h-.109a.4.4,0,0,0-.187.143l-.343.451a.437.437,0,0,0-.087.176.589.589,0,0,0-.036.213.6.6,0,0,0,.036.213.489.489,0,0,0,.087.176l.087.084a.329.329,0,0,0,.209.077l.112-.022a.4.4,0,0,0,.184-.139Z",
    transform: "translate(-69.379 -0.286)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5992",
    "data-name": "Path 5992",
    d: "M291.708,66.084a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-70.589 -0.267)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5993",
    "data-name": "Path 5993",
    d: "M295.036,57.311a.571.571,0,1,0-.419-.551A.5.5,0,0,0,295.036,57.311Z",
    transform: "translate(-71.395 -0.231)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5994",
    "data-name": "Path 5994",
    d: "M298.055,50.356a.571.571,0,1,0-.419-.551A.5.5,0,0,0,298.055,50.356Z",
    transform: "translate(-72.127 -0.203)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5995",
    "data-name": "Path 5995",
    d: "M301.085,46.438a.571.571,0,1,0-.419-.551A.5.5,0,0,0,301.085,46.438Z",
    transform: "translate(-72.861 -0.187)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5996",
    "data-name": "Path 5996",
    d: "M281.057,85.633l.112-.455a.763.763,0,0,0-.042-.422.351.351,0,0,0-.106-.154.282.282,0,0,0-.142-.1l-.112-.022a.358.358,0,0,0-.212.077l-.084.084a.6.6,0,0,0-.109.246c-.036.15-.075.3-.112.451a.585.585,0,0,0,0,.22.49.49,0,0,0,.05.2.378.378,0,0,0,.109.158.263.263,0,0,0,.142.1l.109.022a.331.331,0,0,0,.212-.077l.084-.084a.6.6,0,0,0,.109-.242Z",
    transform: "translate(-67.911 -0.348)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5997",
    "data-name": "Path 5997",
    d: "M281.424,83.02a.571.571,0,1,0-.419-.551A.5.5,0,0,0,281.424,83.02Z",
    transform: "translate(-68.097 -0.337)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5998",
    "data-name": "Path 5998",
    d: "M282.109,82.3l.346-.9a.748.748,0,0,0,.042-.422c-.061-.293-.291-.465-.514-.385a.462.462,0,0,0-.251.253l-.346.9a.748.748,0,0,0-.042.422.579.579,0,0,0,.193.33.337.337,0,0,0,.324.055A.458.458,0,0,0,282.109,82.3Z",
    transform: "translate(-68.176 -0.331)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5999",
    "data-name": "Path 5999",
    d: "M284.152,81.358h.114a.286.286,0,0,0,.162-.048.353.353,0,0,0,.134-.114.44.44,0,0,0,.087-.18.529.529,0,0,0,.036-.209V80.66a.594.594,0,0,0-.109-.242l-.084-.088a.338.338,0,0,0-.212-.073h-.115A.256.256,0,0,0,284,80.3a.342.342,0,0,0-.134.117.393.393,0,0,0-.087.176.492.492,0,0,0-.036.213.5.5,0,0,0,.014.143.6.6,0,0,0,.109.246l.084.084a.365.365,0,0,0,.212.077Z",
    transform: "translate(-68.761 -0.33)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6000",
    "data-name": "Path 6000",
    d: "M292.464,72.132a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-70.772 -0.292)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6001",
    "data-name": "Path 6001",
    d: "M293.034,67.95v-.132a.463.463,0,0,0-.036-.209.453.453,0,0,0-.221-.294.286.286,0,0,0-.162-.048l-.112.022a.429.429,0,0,0-.184.139l-.064.114a.649.649,0,0,0-.059.275v.151a.591.591,0,0,0,.036.213.448.448,0,0,0,.223.29.227.227,0,0,0,.159.048l.112-.018a.384.384,0,0,0,.184-.143l.067-.11a.707.707,0,0,0,.056-.279Z",
    transform: "translate(-70.809 -0.277)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6002",
    "data-name": "Path 6002",
    d: "M294.095,65.835v-.15a.591.591,0,0,0-.036-.213.49.49,0,0,0-.087-.176.314.314,0,0,0-.137-.114.258.258,0,0,0-.159-.048h-.112a.4.4,0,0,0-.187.143l-.064.11a.675.675,0,0,0-.056.279v.15a.533.533,0,0,0,.034.213.5.5,0,0,0,.087.176.313.313,0,0,0,.137.114.24.24,0,0,0,.162.048l.109-.018a.4.4,0,0,0,.187-.143l.064-.11a.724.724,0,0,0,.059-.279Z",
    transform: "translate(-71.066 -0.268)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6003",
    "data-name": "Path 6003",
    d: "M297.757,62.287a.571.571,0,1,0-.419-.551A.5.5,0,0,0,297.757,62.287Z",
    transform: "translate(-72.055 -0.252)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6004",
    "data-name": "Path 6004",
    d: "M299.574,52.929a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-72.495 -0.213)",
    fill: "#f1e1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6005",
    "data-name": "Path 6005",
    d: "M48.743,65.193a2.344,2.344,0,0,0,1,2.492,1.686,1.686,0,0,0,2.128-.8,4.088,4.088,0,0,0,.441-2.937,1.923,1.923,0,0,0-.522-1.076,1.414,1.414,0,0,0-.757-.268,2.179,2.179,0,0,0-1.676.268,1.631,1.631,0,0,0-.433,1.912",
    transform: "translate(-11.802 -0.257)",
    fill: "#a35d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6006",
    "data-name": "Path 6006",
    d: "M-8.665,71.7A47.28,47.28,0,0,0,.886,66.392,49.125,49.125,0,0,0,5.3,62.835a54.8,54.8,0,0,0,4.133-4.119A59.022,59.022,0,0,0,13.243,54.1l1.829-2.456c.6-.826,1.2-1.652,1.824-2.448a31.4,31.4,0,0,1,4-4.4,6.687,6.687,0,0,0,1.011-1,1.807,1.807,0,0,0,.321-.657,1.155,1.155,0,0,0-.053-.708,3.233,3.233,0,0,0-.966-.995c-.355-.3-.748-.558-1.117-.826a18.414,18.414,0,0,0-4.884-2.144c-1.676-.5-3.4-.826-5.113-1.193a48.29,48.29,0,0,1-5.133-1.318,47.924,47.924,0,0,1-5-2.03c-1.65-.764-3.27-1.6-4.87-2.507s-3.184-1.835-4.77-2.76a24,24,0,0,0-4.837-2.4,7.965,7.965,0,0,0-2.55-.367,10.1,10.1,0,0,0-2.558.521v-.073a10.525,10.525,0,0,1,2.564-.679,7.455,7.455,0,0,1,2.62.246,22.774,22.774,0,0,1,4.949,2.235C-6.305,29.9-3.113,31.674.146,33.2a51.47,51.47,0,0,0,4.951,2,45.63,45.63,0,0,0,5.077,1.38c1.726.378,3.429.756,5.127,1.3a18.163,18.163,0,0,1,4.923,2.353,12.239,12.239,0,0,1,1.117.885c.182.158.369.308.559.477a2,2,0,0,1,.483.668,1.525,1.525,0,0,1,.059.947,2.166,2.166,0,0,1-.388.76,6.609,6.609,0,0,1-1.067,1.028,23.072,23.072,0,0,0-2.075,2.037c-.662.734-1.285,1.527-1.9,2.331-1.226,1.608-2.371,3.326-3.549,5.007a58.27,58.27,0,0,1-3.739,4.8A42.721,42.721,0,0,1-8.654,71.773Z",
    transform: "translate(4.755 -0.105)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6007",
    "data-name": "Path 6007",
    d: "M228.788,22.606l.857-.675a.575.575,0,0,0,.193-.33.714.714,0,0,0-.042-.426.458.458,0,0,0-.249-.253.346.346,0,0,0-.324.055l-.86.679a.59.59,0,0,0-.193.33.724.724,0,0,0,.042.422.459.459,0,0,0,.251.253.346.346,0,0,0,.324-.055Z",
    transform: "translate(-55.29 -0.086)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6008",
    "data-name": "Path 6008",
    d: "M232.332,19.233l.514-.9a.524.524,0,0,0,.05-.206.536.536,0,0,0,0-.22.56.56,0,0,0-.193-.33.342.342,0,0,0-.321-.055l-.1.055a.554.554,0,0,0-.151.2l-.514.9a.524.524,0,0,0-.05.206.531.531,0,0,0,0,.22.59.59,0,0,0,.193.33.346.346,0,0,0,.324.055l.1-.055a.588.588,0,0,0,.151-.2Z",
    transform: "translate(-56.113 -0.072)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6009",
    "data-name": "Path 6009",
    d: "M237.264,14.805l.687-1.127a.44.44,0,0,0,.087-.18.464.464,0,0,0,.036-.209.649.649,0,0,0-.123-.389.367.367,0,0,0-.3-.162.352.352,0,0,0-.3.162l-.687,1.127a.439.439,0,0,0-.087.18.464.464,0,0,0-.036.209.648.648,0,0,0,.123.389.367.367,0,0,0,.3.162.352.352,0,0,0,.3-.162Z",
    transform: "translate(-57.323 -0.052)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6010",
    "data-name": "Path 6010",
    d: "M230.46,27.053l.687-1.127a.746.746,0,0,0,.123-.389.648.648,0,0,0-.123-.389.369.369,0,0,0-.3-.162.352.352,0,0,0-.3.162l-.687,1.127a.44.44,0,0,0-.087.18.463.463,0,0,0-.036.209.649.649,0,0,0,.123.389.367.367,0,0,0,.3.162.352.352,0,0,0,.3-.162Z",
    transform: "translate(-55.675 -0.103)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6011",
    "data-name": "Path 6011",
    d: "M234.768,22.291l.681-1.131a.393.393,0,0,0,.087-.176.493.493,0,0,0,.036-.213.5.5,0,0,0-.419-.551.371.371,0,0,0-.3.162l-.687,1.131a.449.449,0,0,0-.087.176.534.534,0,0,0-.036.213.648.648,0,0,0,.123.389.381.381,0,0,0,.3.162.362.362,0,0,0,.3-.162Z",
    transform: "translate(-56.717 -0.083)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6012",
    "data-name": "Path 6012",
    d: "M238.1,18.373a.571.571,0,1,0-.419-.551A.5.5,0,0,0,238.1,18.373Z",
    transform: "translate(-57.599 -0.071)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6013",
    "data-name": "Path 6013",
    d: "M242.255,12.312l.514-.675a.657.657,0,0,0,.123-.389.492.492,0,0,0-.036-.213.393.393,0,0,0-.087-.176.367.367,0,0,0-.3-.162.4.4,0,0,0-.3.162l-.514.675a.662.662,0,0,0-.123.389.492.492,0,0,0,.036.213.393.393,0,0,0,.087.176.367.367,0,0,0,.3.162.381.381,0,0,0,.3-.162Z",
    transform: "translate(-58.533 -0.044)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6014",
    "data-name": "Path 6014",
    d: "M245.673,8.016l.687-1.127a.439.439,0,0,0,.087-.18.463.463,0,0,0,.036-.209.667.667,0,0,0-.123-.393.372.372,0,0,0-.3-.158.357.357,0,0,0-.3.158l-.7,1.131a.449.449,0,0,0-.087.176.5.5,0,0,0-.036.213.648.648,0,0,0,.123.389.367.367,0,0,0,.3.162.352.352,0,0,0,.3-.162Z",
    transform: "translate(-59.359 -0.024)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6015",
    "data-name": "Path 6015",
    d: "M230.461,33.162l1.2-1.806a.706.706,0,0,0,.123-.389.666.666,0,0,0-.123-.389.357.357,0,0,0-.595,0l-1.2,1.806a.675.675,0,0,0-.123.389.648.648,0,0,0,.123.389A.356.356,0,0,0,230.461,33.162Z",
    transform: "translate(-55.675 -0.125)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6016",
    "data-name": "Path 6016",
    d: "M236.583,27.053c.229-.367.458-.734.69-1.127a.712.712,0,0,0,.12-.389.664.664,0,0,0-.12-.389.375.375,0,0,0-.3-.162.357.357,0,0,0-.3.162l-.687,1.127a.48.48,0,0,0-.087.18.567.567,0,0,0-.036.209.666.666,0,0,0,.123.389.369.369,0,0,0,.3.162.352.352,0,0,0,.3-.162Z",
    transform: "translate(-57.158 -0.103)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6017",
    "data-name": "Path 6017",
    d: "M240.665,20.931l.681-1.131a.393.393,0,0,0,.087-.176.492.492,0,0,0,.036-.213.5.5,0,0,0-.419-.551.371.371,0,0,0-.3.162l-.687,1.131a.393.393,0,0,0-.087.176.534.534,0,0,0-.036.213.648.648,0,0,0,.123.389.381.381,0,0,0,.3.162.371.371,0,0,0,.3-.162Z",
    transform: "translate(-58.146 -0.078)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6018",
    "data-name": "Path 6018",
    d: "M244.815,15.6l.343-.9a.758.758,0,0,0,.042-.426.55.55,0,0,0-.193-.327.323.323,0,0,0-.321-.055.453.453,0,0,0-.251.253l-.344.9a.748.748,0,0,0-.042.422.579.579,0,0,0,.193.33.335.335,0,0,0,.33.04.449.449,0,0,0,.249-.253Z",
    transform: "translate(-59.138 -0.057)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6019",
    "data-name": "Path 6019",
    d: "M248.259,11.161l.344-1.131a.685.685,0,0,0-.042-.422.467.467,0,0,0-.249-.253.335.335,0,0,0-.324.055l-.084.084a.6.6,0,0,0-.109.246l-.344,1.127a.733.733,0,0,0,.042.426.462.462,0,0,0,.251.253.331.331,0,0,0,.321-.055l.087-.088a.589.589,0,0,0,.106-.242Z",
    transform: "translate(-59.962 -0.038)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6020",
    "data-name": "Path 6020",
    d: "M251.661,6.4c.117-.367.232-.734.346-1.131a.7.7,0,0,0-.045-.422.449.449,0,0,0-.249-.253.335.335,0,0,0-.324.055l-.084.084a.6.6,0,0,0-.109.242L250.854,6.1a.734.734,0,0,0,.042.426.483.483,0,0,0,.251.253.349.349,0,0,0,.324-.059l.084-.084a.638.638,0,0,0,.106-.242Z",
    transform: "translate(-60.787 -0.019)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6021",
    "data-name": "Path 6021",
    d: "M235.9,32.72q.771-1.244,1.547-2.485a.705.705,0,0,0,0-.778.357.357,0,0,0-.595,0l-1.544,2.485a.669.669,0,0,0-.12.539.5.5,0,0,0,.3.4A.359.359,0,0,0,235.9,32.72Z",
    transform: "translate(-56.991 -0.121)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M241.12,25.694l.687-.9a.675.675,0,0,0,.123-.389.5.5,0,0,0-.419-.551.391.391,0,0,0-.3.162l-.687.9a.675.675,0,0,0-.123.389.649.649,0,0,0,.123.389.381.381,0,0,0,.3.162A.391.391,0,0,0,241.12,25.694Z",
    transform: "translate(-58.258 -0.098)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    "data-name": "Path 6023",
    d: "M244.455,21.775a.571.571,0,1,0-.419-.551A.5.5,0,0,0,244.455,21.775Z",
    transform: "translate(-59.138 -0.085)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6024",
    "data-name": "Path 6024",
    d: "M247.4,18.148a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-59.852 -0.07)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6025",
    "data-name": "Path 6025",
    d: "M249.445,14.971a.571.571,0,1,0-.419-.551A.5.5,0,0,0,249.445,14.971Z",
    transform: "translate(-60.347 -0.057)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6026",
    "data-name": "Path 6026",
    d: "M241.413,29.891l.517-1.354a.757.757,0,0,0,.042-.426.569.569,0,0,0-.193-.327.369.369,0,0,0-.572.195l-.517,1.358a.748.748,0,0,0-.042.422.564.564,0,0,0,.193.33.369.369,0,0,0,.559-.2Z",
    transform: "translate(-58.314 -0.114)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6027",
    "data-name": "Path 6027",
    d: "M244.68,25.635a.571.571,0,1,0-.419-.551A.5.5,0,0,0,244.68,25.635Z",
    transform: "translate(-59.192 -0.101)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6028",
    "data-name": "Path 6028",
    d: "M246.5,23.364a.571.571,0,1,0-.419-.551.5.5,0,0,0,.419.551Z",
    transform: "translate(-59.633 -0.092)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6029",
    "data-name": "Path 6029",
    d: "M248.535,20.869a.571.571,0,1,0-.419-.551A.5.5,0,0,0,248.535,20.869Z",
    transform: "translate(-60.127 -0.081)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6030",
    "data-name": "Path 6030",
    d: "M245.268,30.343c.279-.525.559-1.054.86-1.582a.654.654,0,0,0-.151-.752.342.342,0,0,0-.321-.055.535.535,0,0,0-.251.253l-.86,1.582a.724.724,0,0,0-.042.422.579.579,0,0,0,.193.33.337.337,0,0,0,.324.055.516.516,0,0,0,.249-.253Z",
    transform: "translate(-59.248 -0.115)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6031",
    "data-name": "Path 6031",
    d: "M249.423,25.166q.26-.677.522-1.354a.748.748,0,0,0,.042-.422.579.579,0,0,0-.193-.33A.337.337,0,0,0,249.47,23a.453.453,0,0,0-.251.253l-.519,1.351a.758.758,0,0,0-.042.426.581.581,0,0,0,.193.327.327.327,0,0,0,.324.055.443.443,0,0,0,.249-.25Z",
    transform: "translate(-60.255 -0.095)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6032",
    "data-name": "Path 6032",
    d: "M252.093,21.74c.173-.3.344-.606.514-.907a.49.49,0,0,0,.05-.2.531.531,0,0,0,0-.22c-.067-.287-.3-.45-.517-.367l-.1.055a.523.523,0,0,0-.151.2l-.531.892a.524.524,0,0,0-.05.206.579.579,0,0,0,.193.551.346.346,0,0,0,.324.055l.1-.055a.523.523,0,0,0,.151-.2Z",
    transform: "translate(-60.898 -0.082)",
    fill: "#222d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6033",
    "data-name": "Path 6033",
    d: "M239.034,111.9c2.793-.65,5.675,0,8.5.474,2.957.488,5.934.771,8.909,1.053,2.862.275,5.731.547,8.6.613a26.119,26.119,0,0,1,5.53.437c1.821.437,3.555,1.329,5.359,1.854a13.6,13.6,0,0,0,5.356.488c.595-.066,1.424.073,1.449.855",
    transform: "translate(-57.926 -0.459)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6034",
    "data-name": "Path 6034",
    d: "M247.88,108.48l14.96,2.478c1.955.327,3.91.65,5.89.855a49.18,49.18,0,0,0,5.8.268,15.194,15.194,0,0,1,4.256.308c.882.257,1.726.7,2.6,1,1.821.624,3.765.613,5.516,1.52a.6.6,0,0,1,.341.338c.059.176-.045.437-.187.4",
    transform: "translate(-60.07 -0.446)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6035",
    "data-name": "Path 6035",
    d: "M262.827,104.657l15.122,3.583c2.458.58,4.918,1.164,7.342,1.956,1.983.65,3.938,1.439,5.89,2.228a9.356,9.356,0,0,1,3.566,2.133",
    transform: "translate(-63.691 -0.431)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6036",
    "data-name": "Path 6036",
    d: "M272.038,104.215a79.355,79.355,0,0,1,16.968,3,13.787,13.787,0,0,1,3.7,1.5,9.833,9.833,0,0,0,2.234,1.318,19.557,19.557,0,0,0,2.793.18.356.356,0,0,1,.338.257c.034.176-.232.286-.226.106",
    transform: "translate(-65.924 -0.429)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6037",
    "data-name": "Path 6037",
    d: "M278.031,100.85q6.256,1.226,12.567,1.887c2.793.294,5.778.58,8.048,2.76.933.9,1.938,2.158,3.05,1.751",
    transform: "translate(-67.376 -0.415)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6038",
    "data-name": "Path 6038",
    d: "M288.757,98.657a30.718,30.718,0,0,0,6.49,1.527c1.561.132,3.17.026,4.633.734.866.426,1.639,1.123,2.485,1.608a5.847,5.847,0,0,0,2.363.76",
    transform: "translate(-69.975 -0.406)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6039",
    "data-name": "Path 6039",
    d: "M294.415,96.825a30.969,30.969,0,0,0,6.228,2.786c1.137.319,2.3.5,3.421.914a5.916,5.916,0,0,1,2.988,2.254",
    transform: "translate(-71.346 -0.398)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.369
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6040",
    "data-name": "Path 6040",
    d: "M298.926,96.571a10.919,10.919,0,0,0,3.547,1.061,5.643,5.643,0,0,1,3.351,1.751",
    transform: "translate(-72.44 -0.397)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.369
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscipleCoverOnDisplay);
export default __webpack_public_path__ + "static/media/Disciple Cover On Display.cc714368d5e4a882a15f26d02525070c.svg";
export { ForwardRef as ReactComponent };